<template>
  <v-container class="wrapper">
    <v-form ref="createEstimateRepairerForm" v-model="formValid" class="wrapper">
      <div>
        <v-col cols="12" class="px-0">
          <p required="true" class="text-field">{{ $t('ESTIMATE_REPAIRER.REPAIRER_NUMBER') }}</p>
          <v-text-field
            v-model="repairerNumber"
            :placeholder="$t('ESTIMATE_REPAIRER.PLACEHOLDER.REPAIRER_NUMBER')"
            :rules="requiredRules"
            :error-messages="error?.repairerNumber"
            :maxlength="15"
            hide-details="auto"
          />
          <p
            v-html="$t('ESTIMATE_REPAIRER.HINT.REPAIRER_NUMBER').replace(/\n/g, '<br>')"
            class="custom-hint"
          />
        </v-col>
      </div>
      <div class="bottom-content">
        <v-col cols="12" class="px-0">
          <v-btn
            class="boom-button w-100"
            :disabled="loading || !formValid"
            :loading="loading"
            variant="outlined"
            @click="submit"
          >
            {{ $t('COMMON.BUTTON.CONTINUE') }}
          </v-btn>
        </v-col>
        <v-btn
          class="button w-100"
          :loading="loading"
          variant="outlined"
          @click="$emit('cancelEstimateRepairer')"
        >
          {{ $t('COMMON.BUTTON.CANCEL') }}
        </v-btn>
      </div>
    </v-form>
  </v-container>
</template>

<script>
import RepairFileService from '@/services/RepairFileService'
import ResponseConstant from '@/constants/responseConstant'
import { auth as $store } from '@/store/AuthModule'
import { handleResponseError } from '@/components/utils/globalFunction'
import Validator from '@/components/utils/validator'

export default {
  props: {
    currentRepairFile: Object
  },
  data() {
    return {
      formValid: false,
      loading: false,
      error: null,
      repairerNumber: '',
      requiredRules: Validator.requiredRules
    }
  },
  created() {
    if (this.currentRepairFile?.repairer_estimate) {
      this.repairerNumber = this.currentRepairFile.repairer_estimate.repairer_number
    }
  },
  watch: {
    repairerNumber(repairerNumber) {
      this.$emit('repairerNumber', repairerNumber)
    }
  },
  methods: {
    async submit() {
      this.loading = true
      try {
        if (this.currentRepairFile?.repairer_estimate) {
          await this.updateRepairerEstimate()
        } else {
          await this.createRepairerEstimate()
        }
        this.$emit('nextStepEstimateInOffer')
      } catch (error) {
        handleResponseError(error)
        if (error.response?.data && error.response.data.key in ResponseConstant) {
          this.setError(error.response.data.key)
        }
      } finally {
        this.loading = false
      }
    },
    getCurrentCollaborator() {
      return $store.state.currentCollaborator
    },
    setError(key) {
      switch (key) {
        case 'invalid_repairer_repair_file_number_error_key':
          this.error = { repairerNumber: this.$t('ERROR.' + ResponseConstant[key]) }
          break
        default:
          this.error = ''
      }
    },
    async createRepairerEstimate() {
      const data = {
        requestor_collaborator_id: this.getCurrentCollaborator().technical_id,
        repairer_number: this.repairerNumber,
        repair_file_id: this.currentRepairFile.technical_id
      }
      await RepairFileService.createRepairFileRepairerEstimate(data)
    },
    async updateRepairerEstimate() {
      const data = {
        requestor_collaborator_id: this.getCurrentCollaborator().technical_id,
        repairer_number: this.repairerNumber,
        repair_file_id: this.currentRepairFile.technical_id,
        repairer_estimate_id: this.currentRepairFile.repairer_estimate.technical_id
      }
      return RepairFileService.updateRepairFileRepairerEstimate(data)
    }
  }
}
</script>

<style scoped>
.text-field {
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px;
  margin-bottom: 10px;
}

.button {
  display: flex;
  padding: 10px 20px;
  justify-content: center;
  align-items: center;
  text-transform: none !important;
  border-radius: 20px;
  border: 1px solid #000;
  background: #fff;
  color: #000;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}

.boom-button {
  padding: 10px 20px !important;
}

:deep(.v-infinite-scroll__side) {
  padding: unset;
}

.wrapper {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
}

.bottom-content {
  margin-top: auto;
}
</style>
